import styles from './FullscreenSpinner.module.css'
import Spinner from "../spinner/Spinner"
import { useEffect } from 'react'

interface fullscreenSpinnerProps {
    visible: boolean
}

export default function FullscreenSpinner({ visible }: fullscreenSpinnerProps) {
    useEffect(() => {
        const body = document.body

        body.style.overflow = visible ? 'hidden' : 'auto'

        return(() => {
            body.style.overflow = 'auto'
        })
    }, [visible])

    const spinnerContainerClassName = `${styles.spinnerContainerClassName} ${visible ? styles.fadeIn : styles.fadeOut}`

    return <Spinner spinnerContainerClassName={ spinnerContainerClassName } />
}